import { render } from "./HomeComponent.vue?vue&type=template&id=3f70f010"
import script from "./HomeComponent.vue?vue&type=script&lang=js"
export * from "./HomeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__